import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


//************* VOTACION  ***************************/
import { Interceptor } from '../../token/interceptor';
import { EstamentosService } from '../estamentos/estamentos.service';
import { ProcesosElectoralesService } from '../procesosElectorales/procesosElectorales.service';
import { ListasService } from '../listas/listas.service';
import { CandidatosEscaniosService } from '../candidatosEscanios/candidatosEscanios.service';
import { EscanosConfigService } from '../escanosConfig/escanosConfig.service';
import { PadronesService } from '../padrones/padrones.service';
import { VotosRealesService } from '../votosReales/votosReales.service';
import { AsignacionEscaniosService } from '../asignacionEscanios/asignacionEscanios.service';
import { ResultadosPonderadosService } from '../resultadosPonderados/resultadosPonderados.service';
import { VotosIndividualesService } from '../votosIndividuales/votosIndividuales.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedVotacionModule {
  static forRoot(): ModuleWithProviders<SharedVotacionModule> {
    return {
      ngModule: SharedVotacionModule,
      providers: [
        EstamentosService, ProcesosElectoralesService, ListasService, CandidatosEscaniosService,
        EscanosConfigService,PadronesService ,VotosRealesService,AsignacionEscaniosService,
        ResultadosPonderadosService,VotosIndividualesService,
        // ProcesosElectoralesService ,CalculoService,  PadronService, ProcesoService, ,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
